// extracted by mini-css-extract-plugin
export default {"printButton":"PrintButton_printButton__W8ztS","buttonDisabled":"PrintButton_buttonDisabled__Kmkab"};